module.exports = __webpack_public_path__ + "static/media/S4N4-4.4facfb36.svg";